<div class="activityWrapper">
  <span
    class="descriptionActivity"
    [class.descriptionActivity--comment]="ppComment"
    [class.descriptionActivity--collapsed]="!expanded"
    #description
  ></span>

  @if (ppComment) {
    <span
      ppTooltip
      [ppTitle]="reactionTooltip"
      [ppSanitize]="false"
      [class.activityChange__like-comment--short]="!reaction || reaction?.like.length === 0"
      [ppOptions]="{ placement: 'bottom' }"
      class="activityChange__like-comment"
      (click)="likeComment()"
      >
      <span class="activityChange__liked-panel__content">
        @if (!reaction?.like.includes(user.userId)) {
          <pp-icon
            class="likeButton--secondary activityChange__liked-panel-icon"
            [class.activityChange__liked-panel-icon--single]="!reaction || reaction?.like.length === 0"
            [ppSrc]="EIconPath.INTERACTION_LIKE"
            [ppColor]="reaction?.like.length > 0 ? 'primary-600' : 'inherit'"
            ></pp-icon>
        }
        @if (reaction?.like.includes(user.userId)) {
          <pp-icon
            class="likeButton--secondary activityChange__liked-panel-icon"
            [ppSrc]="EIconPath.INTERACTION_LIKE_FILLED"
            ppColor="primary-950"
            ></pp-icon>
        }
        @if (reaction?.like.length > 0) {
          <p class="activityChange__liked-panel-text copySmall">
            {{ reaction.like.length }}
          </p>
        }
      </span>
    </span>
  }

  <div class="activityChange__show-more-less richTextActivity__options">
    @if (!expanded && long) {
      <span class="ppLink" (click)="expandDescription()">
        {{ 'show_more' | ppTranslate }}
      </span>
    }

    @if (expanded && long) {
      <span class="ppLink" (click)="collapseDescription()">
        {{ 'show_less' | ppTranslate }}
      </span>
    }

    @if (ppShowEdit) {
      <button class="commentEditButton" (click)="edit()">
        {{ 'edit' | ppTranslate }}
      </button>
    }
  </div>
</div>
